import { createEnv } from '@t3-oss/env-core';
import { clientSchema, serverSchema } from './schema';
/**
 * Runtime-validated environment configuration using t3-env
 *
 * This object provides type-safe access to environment variables with Zod validation. Variables are validated at
 * runtime when this module is first imported.
 *
 * @example
 *   ```typescript
 *   import { env, isProduction } from '@repo/environment';
 *
 *   // Access client-side variables
 *   const apiUrl = env.PUBLIC_CORE_API_BASE_URL;
 *
 *   // Use production helper
 *   if (isProduction) {
 *     console.log('Running in production mode');
 *   }
 *   ```;
 */ export const env = createEnv({
    clientPrefix: 'PUBLIC_',
    client: clientSchema,
    server: serverSchema,
    runtimeEnv: {
        PUBLIC_ENV: process.env.PUBLIC_ENV,
        PUBLIC_CORE_API_BASE_URL: process.env.PUBLIC_CORE_API_BASE_URL,
        PUBLIC_AUTH_API_BASE_URL: process.env.PUBLIC_AUTH_API_BASE_URL,
        PUBLIC_FEEDBACK_API_URL: process.env.PUBLIC_FEEDBACK_API_URL,
        PUBLIC_STRIPE_PK_KEY: process.env.PUBLIC_STRIPE_PK_KEY,
        PUBLIC_STRIPE_PRICE_PERSONAL: process.env.PUBLIC_STRIPE_PRICE_PERSONAL,
        PUBLIC_STRIPE_PRICE_STANDARD: process.env.PUBLIC_STRIPE_PRICE_STANDARD,
        PUBLIC_STRIPE_PRICE_USERS: process.env.PUBLIC_STRIPE_PRICE_USERS,
        PUBLIC_CERBOS_HUB_BUNDLE_URL: process.env.PUBLIC_CERBOS_HUB_BUNDLE_URL,
        PUBLIC_USE_SENTRY: process.env.PUBLIC_USE_SENTRY,
        PUBLIC_SENTRY_DSN: process.env.PUBLIC_SENTRY_DSN,
        PUBLIC_SENTRY_RELEASE: process.env.PUBLIC_SENTRY_RELEASE,
        PUBLIC_INTERCOM_APP_ID: process.env.PUBLIC_INTERCOM_APP_ID,
        PUBLIC_GTM_ID: process.env.PUBLIC_GTM_ID
    },
    emptyStringAsUndefined: true
});
/** Helper to check if the application is running in production mode */ export const isProduction = env.PUBLIC_ENV === 'production';
